import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkudmq7x6t: FaireProductEntity = {
  token: "p_nkudmq7x6t",
  type: "product",
  name: "Ribbed Heather Hoodie And Pants Set (1)",
  brandToken: "b_2uphvkwhlc",
  brandName: "Dress Forum",
  imageUrl:
    "https://cdn.faire.com/fastly/2391522d97aa9697e177e5a21f015fb8003978c581a617e4904e4c157af90a16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0c7bf6fba7643c8525ab365b214dac9236740817008ba44f339bb9275a2f0c3.jpeg",
    "https://cdn.faire.com/fastly/1e15c55c42b753c74215ca8aae05ad7c4d8129c6d78aec722ee19f1789522a64.jpeg",
    "https://cdn.faire.com/fastly/13df0685c07281adf9435ab108191c1877aaee1001895094c946d205d8a2ff2b.jpeg",
    "https://cdn.faire.com/fastly/31142bf5f6c7687b52980681f1e9f8b3bbff178f211754bba9254d8c85091a08.jpeg",
    "https://cdn.faire.com/fastly/c0cad1332dd941b0b75919bc976d9a26b356828ce26f8ee5e11f198f9ad1b86c.jpeg",
    "https://cdn.faire.com/fastly/daf2783f0694c005c3c5bf4298a39c173d9d74cbae63245f23a1541bade5a378.jpeg",
    "https://cdn.faire.com/fastly/b708d8f448fbf5e8e0b96f9aba24f4fe67df4fa39c2ba430cee6cf00972aba49.jpeg",
    "https://cdn.faire.com/fastly/c6d3a150e6ae3e019b8dbc430463d97fc4aa7ba015caf2b151a5baf96ad8c6c5.jpeg",
    "https://cdn.faire.com/fastly/3687074f3cb79f90bd937dc6afd71719228ab99dc3697d3e5e3d07fd113be132.jpeg",
    "https://cdn.faire.com/fastly/26572c91ed7106ad5228425b3e6d3b40053ddb71c18cd2ce30a7142fc0d93f8b.jpeg",
    "https://cdn.faire.com/fastly/bea7afed414d68cd0b2ee8883fc8bd0111a67241f5704f570a627262f598ecd8.jpeg",
    "https://cdn.faire.com/fastly/79259add6dac3b5cd44727a2a55af809c6ebf4cfb2062dca0bac67a99915a8d5.jpeg",
    "https://cdn.faire.com/fastly/3c1034f70cc04a06afcf57e946fc5200c0c733a8e2634323805e4e78b81d02a4.jpeg",
    "https://cdn.faire.com/fastly/fd29a9b3f58f2051791160cca5ac4fdab68e8978d4e5ea735fd30fd63ee1b7d5.jpeg",
    "https://cdn.faire.com/fastly/ecbc50119769a88584a3457651b155336815f7527101168e253b5fce6b642cc9.jpeg",
    "https://cdn.faire.com/fastly/cecdf631452d119380b633fc3467099550e7f4fc6b215b36797e046389458885.jpeg",
  ],
  priceDollars: 25,
  description:
    "FF11242-P1285\r\n\r\nRibbed hoodie and pants with drawstring fastening and side pockets. Model is 5'8\" and wearing size Small.\r\n\r\nShell: 76% Polyester, 20% Rayon, 4% Spandex\r\nLining: N/A",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:31.703Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
